import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import $ from "jquery";
import i18n from "i18next";
import { I18nextProvider } from "react-i18next";
import capitalize from "capitalize";
import App from "./App";
import * as RegisterServiceWorker from "./registerServiceWorker";
import { POSSIBLE_LANGUAGES } from "./constants/languages";
import env from "./environmentVariables";
import addHotjar from "./addHotjar";
import globalConfig from "./config";
import * as resources from "./locales";
import { UserManager } from 'oidc-client';

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

$.get("/config", function (config) {
    Object.assign(globalConfig, config);

    authenticate();
});

function authenticate() {
    const userStore = { 
        get: function () { return Promise.resolve(); },
        set: function () { return Promise.resolve(); }
    };

    const userManager = new UserManager({
        authority: globalConfig.identityServer.baseUrl,
        client_id: globalConfig.identityServer.clientId,
        redirect_uri: window.location.origin + '/signin-oidc',
        prompt: 'none',
        scope: 'openid profile_scoodleportal',
        userStore: userStore
    })

    if (window.location.pathname.indexOf('/signin-oidc') === 0) {
        userManager.signinRedirectCallback().then(
            user => {
                globalConfig.user = user;
                window.history.replaceState(null, '', user.state.returnUrl);
            },
            reason => {
                globalConfig.user = null;
                window.history.replaceState(null, '', reason.state.returnUrl);
            })
            .then(renderApp);
    }
    else {
        userManager.signinRedirect({
            state: {
                returnUrl: window.location.pathname + window.location.search
            }
        });
    }
}

function renderApp() {
    const i18nOptions = {
        debug: false,
        defaultNS: "common", // this namespace will be used if no namespace shared via context
        fallbackNS: "common",
        ns: [
            "common",
        ],
        lng: globalConfig.language,
        resources,
        whitelist: POSSIBLE_LANGUAGES,
        interpolation: {
            escapeValue: false,
            format: (value, format, lng) => {
                switch (format) {
                    case "capitalize":
                        return capitalize(value)
                    default:
                        return value;
                }
            }
        },
        react: {
            wait: true
        }
    };

    i18n
        .init(i18nOptions, () => {
            ReactDOM.render(
                <I18nextProvider i18n={i18n}>
                    <BrowserRouter basename={baseUrl}>
                        <App />
                    </BrowserRouter>
                </I18nextProvider>,
                rootElement
            );
        });

    if (env.REACT_APP_ENABLE_HOTJAR === "true") {
        addHotjar();
    }

    RegisterServiceWorker.unregister();
}


// WEBPACK FOOTER //
// ./src/index.js